import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CoursesPage } from './courses.page';

const routes: Routes = [
	{
		path: '',
		component: CoursesPage,
	},
	{
		path: ':id/cohorts',
		loadChildren: () =>
			import('./cohorts/cohorts.module').then(m => m.CohortsPageModule),
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class CoursesPageRoutingModule {}
